export type UserRoles = "admin" | "clinical_coder_admin" | "clinical_coder";

export const USER_ROLES: Record<UserRoles, UserRoles> = {
  admin: "admin",
  clinical_coder_admin: "clinical_coder_admin",
  clinical_coder: "clinical_coder",
};
